import { JSX } from 'react'

import { IconProps } from '../../icon'

const EmptyFolder: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M35.4872 14.9231H25.7559C25.0667 14.9231 24.4267 14.5785 24.0492 14.0041L22.72 12.0021C21.8831 10.7385 20.4718 10 18.9621 10H12.5128C10.0185 10 8 12.0185 8 14.5128V32.5641C8 35.0585 10.0185 37.0769 12.5128 37.0769H35.4872C37.9815 37.0769 40 35.0585 40 32.5641V19.4359C40 16.9415 37.9815 14.9231 35.4872 14.9231ZM37.5385 32.5641C37.5385 33.6964 36.6195 34.6154 35.4872 34.6154H12.5128C11.3805 34.6154 10.4615 33.6964 10.4615 32.5641V14.5128C10.4615 13.3805 11.3805 12.4615 12.5128 12.4615H18.9621C19.6513 12.4615 20.2913 12.8062 20.6687 13.3805L21.9979 15.3826C22.8349 16.6462 24.2462 17.3846 25.7559 17.3846H35.4872C36.6195 17.3846 37.5385 18.3036 37.5385 19.4359V32.5641Z'
      fill='black'
    />
    <path
      d='M24.0329 24.7692C23.36 24.7692 22.8021 25.3272 22.8021 26C22.8021 26.6728 23.36 27.2308 24.0329 27.2308C24.7057 27.2308 25.2636 26.6728 25.2636 26C25.2636 25.3272 24.7221 24.7692 24.0329 24.7692Z'
      fill='black'
    />
    <path
      d='M30.5969 24.7692C29.9241 24.7692 29.3662 25.3272 29.3662 26C29.3662 26.6728 29.9241 27.2308 30.5969 27.2308C31.2698 27.2308 31.8277 26.6728 31.8277 26C31.8277 25.3272 31.2862 24.7692 30.5969 24.7692Z'
      fill='black'
    />
    <path
      d='M17.4687 24.7692C16.7959 24.7692 16.238 25.3272 16.238 26C16.238 26.6728 16.7959 27.2308 17.4687 27.2308C18.1416 27.2308 18.6995 26.6728 18.6995 26C18.6995 25.3272 18.158 24.7692 17.4687 24.7692Z'
      fill='black'
    />
  </svg>
)

export default EmptyFolder
